import { Box, Stack } from '@mui/material';

import { Icon } from '@/components/shared/icon';

export type TagStatus = 'active' | 'inactive' | 'pending' | 'error';

export const StatusTag = ({
  status,
  label,
  icon,
}: {
  status: TagStatus;
  label: string;
  icon: string;
}) => {
  const backgroundColor =
    status === 'active'
      ? '#d4ffe4'
      : status === 'inactive'
        ? '#F5F5F5'
        : status === 'pending'
          ? '#FFE8DB'
          : '#F5F5F5';
  const color =
    status === 'active'
      ? '#44af88'
      : status === 'inactive'
        ? '#b2bec1'
        : status === 'pending'
          ? '#FE5C00'
          : '#b2bec1';

  return (
    <Box
      sx={{
        borderRadius: '4px',
        height: '32px',
        width: 'auto',
        fontWeight: 500,
        backgroundColor,
      }}
    >
      <Stack
        direction='row'
        alignItems={'center'}
        justifyContent={'space-evenly'}
      >
        <Box sx={{ paddingLeft: '4px' }}>
          <Icon color={color} iconClass={icon} />
        </Box>
        <Box
          sx={{
            fontSize: '12px',
            height: '32px',
            paddingRight: '12px',
            fontWeight: 500,
            lineHeight: '32px',
            color,
          }}
        >
          {label}
        </Box>
      </Stack>
    </Box>
  );
};
